import { toast } from "sonner";
import { Pencil } from "lucide-react";
import { ItemTypeChip } from "./ItemTypeChip";
import { RowActions } from "../../components/data/RowActions";
import { localName } from "../../lib/localName";

const mono = (value) => <span className="num font-mono text-[11px] text-muted-foreground">{value || "—"}</span>;

// أعمدة جدول المواد المركزية: الكود · الاسم · النوع · التصنيف · الوحدة · الماركة · السعر المرجعي · الحسابات.
export const itemColumns = ({ t, i18n, onEdit, onDelete }) => {
  const ar = i18n.language === "ar";
  return [
    { key: "item_code", label: t("purchases.items.code"), render: (row) => mono(row.item_code) },
    { key: "name", label: t("purchases.items.name"),
      render: (row) => (
        <span className="block max-w-[260px] truncate text-xs font-bold">
          {(localName(row)) || row.name_ar}
          <span className="block truncate text-[10px] font-normal text-muted-foreground">
            {(ar ? row.name_en : row.name_ar) || row.brand || ""}
          </span>
        </span>
      ) },
    { key: "item_type", label: t("purchases.items.type"), render: (row) => <ItemTypeChip type={row.item_type} /> },
    { key: "category", label: t("purchases.items.category"),
      render: (row) => <span className="text-[11px]">{(ar ? row.category_name_ar : row.category_name_en) || "—"}</span> },
    { key: "unit", label: t("purchases.items.uom"),
      render: (row) => <span className="num text-[11px]">{t(`purchases.units.${row.unit}`, row.unit)}</span> },
    { key: "brand", label: t("purchases.items.brand"), render: (row) => <span className="text-[11px]">{row.brand || "—"}</span> },
    { key: "price", label: t("purchases.items.refPrice"),
      render: (row) => (
        <span className="num font-mono text-[11px]">
          {row.reference_price != null ? `${row.reference_price} ±${row.tolerance_percent}% ${row.currency}` : "—"}
          {row.last_purchase_price != null ? (
            <span className="block text-[10px] text-muted-foreground">{t("purchases.items.lastPrice")}: {row.last_purchase_price}</span>
          ) : null}
        </span>
      ) },
    { key: "accounts", label: t("purchases.items.accounts"),
      render: (row) => mono([row.asset_account_code, row.expense_account_code].filter(Boolean).join(" / ")) },
    { key: "stock", label: t("purchases.items.stockRules"),
      render: (row) => row.item_type === "inventory"
        ? mono(`${row.min_stock ?? "—"} / ${row.reorder_point ?? "—"} / ${row.max_stock ?? "—"}`) : mono("") },
    { key: "actions", label: t("purchases.cols.actions"),
      render: (row) => (
        <div className="flex items-center justify-end gap-1">
          <button type="button" title={t("app.edit")} data-testid={`item-edit-${row.item_id}`}
                  onClick={(e) => { e.stopPropagation(); onEdit(row); }}
                  className="rounded-xl p-2 text-muted-foreground shadow-neu-sm hover:text-primary">
            <Pencil className="h-4 w-4" />
          </button>
          <RowActions testid={`item-actions-${row.item_id}`}
                      actions={[{ key: "delete", title: t("app.delete"),
                                  onClick: () => onDelete(row).catch(() => toast.error(t("errors.generic"))) }]} />
        </div>
      ) },
  ];
};
